export default {"src":"/_next/static/media/bell-slateus.8807504f.svg","height":100,"width":100};